import React from 'react'
import { GlobalStyle } from '../styles/GlobalStyle'
import { Header } from './Header'
import { Footer } from './Footer'
import { graphql, useStaticQuery } from 'gatsby'
import { Container } from './Container'
import { SideMenu } from './SideMenu/SideMenu'

const Layout = ({ children, heroBanner, className }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className={className}>
      <GlobalStyle />
      <Header title={site.siteMetadata.title} />
      {heroBanner}
      <Container>
        <main>{children}</main>
        <SideMenu />
      </Container>
      <Footer />
    </div>
  )
}

export default Layout
